var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('b-alert', {
    staticClass: "mb-3",
    attrs: {
      "show": _vm.hasError,
      "variant": "danger"
    }
  }, [_vm._v(" Fout bij het voltooien van de order. ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isSaving
    },
    on: {
      "click": _vm.finish
    }
  }, [!_vm.isSaving ? _c('span', [_vm._v("Markeer als verzonden")]) : _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('strong', [_vm._v("Voltooi deze order")])]);

}]

export { render, staticRenderFns }